import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Option, Select, TextField, Typography } from '@getgo/chameleon-web/react';
import classNames from 'classnames';
import { getIn, useFormikContext } from 'formik';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './TimeField.module.scss';
var TimeUnits;
(function (TimeUnits) {
    TimeUnits["SECONDS"] = "seconds";
    TimeUnits["MINUTES"] = "minutes";
    TimeUnits["HOURS"] = "hours";
})(TimeUnits || (TimeUnits = {}));
const secondsConverter = {
    [TimeUnits.SECONDS]: time => time,
    [TimeUnits.MINUTES]: time => time * 60,
    [TimeUnits.HOURS]: time => time * 3600,
};
const unitsConverter = {
    [TimeUnits.SECONDS]: time => time,
    [TimeUnits.MINUTES]: time => time / 60,
    [TimeUnits.HOURS]: time => time / 3600,
};
const TimeSettingsField = ({ name, label, helperText, disabled, className, }) => {
    const { t } = useTranslation();
    const [unit, setUnit] = useState(TimeUnits.SECONDS);
    const { setFieldValue, values, errors } = useFormikContext();
    const value = unitsConverter[unit](getIn(values, name));
    if (+value !== Math.floor(value)) {
        Object.keys(unitsConverter)
            .reverse()
            .forEach(timeUnit => {
            const value = unitsConverter[timeUnit](getIn(values, name));
            if (value === Math.floor(value)) {
                setUnit(timeUnit);
            }
        });
    }
    const unitsLabels = {
        [TimeUnits.SECONDS]: t('seconds'),
        [TimeUnits.MINUTES]: t('minutes'),
        [TimeUnits.HOURS]: t('hours'),
    };
    return (_jsxs("div", Object.assign({ className: classNames(classes.timeField, className) }, { children: [_jsxs("div", Object.assign({ className: classes.timeField__description }, { children: [_jsx(Typography, Object.assign({ variant: "body-medium" }, { children: label }), void 0), helperText ? (_jsx(Typography, Object.assign({ variant: "body-small", color: "text-02" }, { children: helperText }), void 0)) : null] }), void 0), _jsxs("div", Object.assign({ className: classes.timeField__value }, { children: [_jsx(TextField, { className: classes.timeField__text, fieldsize: "small", disabled: disabled, error: !!getIn(errors, name), helperText: getIn(errors, name), value: value, onChange: event => {
                            setFieldValue(name, secondsConverter[unit](event.target.value), true);
                        } }, void 0), _jsx(Select, Object.assign({ className: classes.timeField__select, fullwidth: true, disabled: disabled, size: "small", value: unit, onChange: event => {
                            setFieldValue(name, secondsConverter[event.target.value](value), false);
                            setUnit(event.target.value);
                        } }, { children: Object.keys(TimeUnits).map(unit => (_jsx(Option, Object.assign({ value: TimeUnits[unit] }, { children: unitsLabels[TimeUnits[unit]] }), unit))) }), void 0)] }), void 0)] }), void 0));
};
export default TimeSettingsField;
//# sourceMappingURL=TimeField.js.map